import moment from 'moment';
const namespaced = true;
class State {
    constructor() {
        this.nowDateTime = moment().utc();
        this.timeZone = moment().utcOffset() / 60;
    }
}
const getters = {
    getNowDateTime: state => state.nowDateTime,
    getUserTimezone: state => state.timeZone
};
const actions = {};
const mutations = {
    setNowDateTime(state) {
        state.nowDateTime = moment().utc();
    }
};
export default {
    namespaced,
    state: new State(),
    getters,
    actions,
    mutations
};
